// extracted by mini-css-extract-plugin
export default {"settings":"RO10U9MvewxNEzHGKPhg","layout":"JfyLq5d0A0ZJOT7qvApT"};